import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

function CategoryChips_1({ item }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <>
      {item?.data?.images?.length > 0 ?
        <div
          className="h-full w-full overflow-hidden pointer-events-auto"
          style={{
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className="overflow-auto h-full w-full">
            <div
              className="flex flex-row justify-start items-center"
              style={{ padding: customization?.containerPadding, gap: 8 }}
            >
              {item?.data?.images?.map((item, index) => (
                <div key={index} style={{ display: 'flex' }}>
                  <div
                    style={{
                      gap: 10,
                      backgroundColor: customization?.innerBackgroundColor,
                      borderStyle: 'solid',
                      borderWidth: 1,
                      borderColor: customization?.borderColor,
                      borderRadius: customization?.borderRadius,
                      padding: customization?.padding,
                      color: customization?.textColor,
                      fontSize: customization?.textSize,
                      fontWeight: customization?.textWeight,
                    }}
                    className="truncate"
                  >
                    {item?.image?.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> :
        <img src={item?.placeholderImage} className={` w-full `} />
      }
    </>
  );
}

export default CategoryChips_1;
